// extracted by mini-css-extract-plugin
export default {"text":"DeletePublicPasswordDialog__text--DTZ3o","dialog":"DeletePublicPasswordDialog__dialog--vtA5s"};